import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26e177d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "project-survey-picker d-flex flex-row align-items-center" }
const _hoisted_2 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_3 = {
  class: "dropdown-menu dropdown-menu-dark",
  "aria-labelledby": "projectDropdown"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "separator"
}
const _hoisted_6 = {
  key: 2,
  class: "dropdown"
}
const _hoisted_7 = {
  class: "dropdown-menu dropdown-menu-dark",
  "aria-labelledby": "surveyDropdown"
}
const _hoisted_8 = ["onClick"]

import { computed, onMounted, reactive } from "vue";
import { useAppStateStore } from "@/store/app-state";
import { Utils } from "@/classes/utils/utils";
import { useDataStore } from "@/store/data-store";
import { ProjectInfo, Survey } from "@/swagger";
import { useUserStore } from "@/store/user-store";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectSurveyPicker',
  props: {
	showProject: {
		type: Boolean,
		default: true
	},
	showSurvey: {
		type: Boolean,
		default: true
	}
},
  setup(__props) {

const prop = __props;


const dataStore = useDataStore();
const userStore = useUserStore();
const appState = useAppStateStore();



const state = reactive({
	projects: [] as ProjectInfo[],
});

const selectedProjectName = computed(() => {
	return appState.project?.name;
});

const selectedSurveyName = computed(() => {
	if(appState.project?.surveys?.length === 0){
		return "No surveys";
	}
	if(!appState.view1Survey){
		return "Select a survey";
	}
	return Utils.formatSurveyName(appState.view1Survey);
});

async function loadProjectSurveys(project: ProjectInfo) {
	//Load project surveys
	await appState.loadProject(project.uuid);

	//Load first survey
	if (!appState.view1Survey && appState.project?.surveys.length > 0) {
		appState.setView1Survey(appState.project.surveys[0]);
	}
}

function selectSurvey(survey: Survey) {
	appState.setView1Survey(survey);
}

onMounted(async () => {
	//Get projects
	if ((prop.showProject || prop.showSurvey)) {
		if (userStore.isLoggedIn()) {
			state.projects = await dataStore.getProjects(true);
		}
	}
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (prop.showProject)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("a", {
            class: _normalizeClass(["project-dropdown dropdown-link", { 'disabled': state.projects.length <= 1 }]),
            href: "#",
            role: "button",
            id: "projectDropdown",
            "data-bs-toggle": "dropdown",
            "aria-expanded": "false"
          }, _toDisplayString(_unref(selectedProjectName)), 3),
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.projects, (project) => {
              return (_openBlock(), _createElementBlock("li", {
                key: project.uuid
              }, [
                _createElementVNode("button", {
                  class: "dropdown-item",
                  type: "button",
                  onClick: ($event: any) => (loadProjectSurveys(project))
                }, _toDisplayString(project.name), 9, _hoisted_4)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (prop.showProject && prop.showSurvey)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, "  /  "))
      : _createCommentVNode("", true),
    (prop.showSurvey && _unref(appState).project && _unref(appState).project.surveys.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("a", {
            class: _normalizeClass(["survey-dropdown dropdown-link", { 'disabled': _unref(appState).project.surveys.length <= 1 }]),
            href: "#",
            role: "button",
            id: "surveyDropdown",
            "data-bs-toggle": "dropdown",
            "aria-expanded": "false"
          }, _toDisplayString(_unref(selectedSurveyName)), 3),
          _createElementVNode("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appState).project.surveys, (survey) => {
              return (_openBlock(), _createElementBlock("li", {
                key: survey.uuid
              }, [
                _createElementVNode("button", {
                  class: "dropdown-item",
                  type: "button",
                  onClick: ($event: any) => (selectSurvey(survey))
                }, _toDisplayString(_unref(Utils).formatSurveyName(survey)), 9, _hoisted_8)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})